// Content warning: this file handles profanity/slur detection.
// Variable names and logic reference offensive language categories
// but no explicit slurs are written in the source code.

import { Profanity } from '@2toad/profanity';

const profanity = new Profanity({ wholeWord: true });

/** Apply leet-speak substitutions without stripping whitespace. */
const normalizeLeet = (text: string): string =>
  text
    .toLowerCase()
    .replace(/0/g, 'o')
    .replace(/1/g, 'i')
    .replace(/3/g, 'e')
    .replace(/4/g, 'a')
    .replace(/5/g, 's')
    .replace(/\$/g, 's')
    .replace(/@/g, 'a')
    .replace(/!/g, 'i');

/**
 * Collapse runs of single characters separated by delimiters into words.
 * e.g. "f u c k you" → "fuck you", "s-h-i-t" → "shit"
 * Multi-character tokens like "bass" are left untouched.
 */
const collapseSingleCharRuns = (text: string): string =>
  text.replace(
    /(?:^|\s)([a-z0-9])(?:[\s\-_.]+[a-z0-9]){2,}(?=\s|$)/gi,
    (match) => match.replace(/[\s\-_.]+/g, '')
  );

export const isProfane = (query: string): boolean => {
  if (!query.trim()) {
    return false;
  }

  // 1. Raw query with whole-word matching (catches "this is shit")
  if (profanity.exists(query)) {
    return true;
  }

  const leet = normalizeLeet(query);

  // 2. Leet-normalized, whole-word (catches "sh1t", "a$$")
  if (profanity.exists(leet)) {
    return true;
  }

  // 3. Collapse single-char evasion + leet (catches "f u c k you" → "fuck you")
  const collapsed = collapseSingleCharRuns(leet);
  if (profanity.exists(collapsed)) {
    return true;
  }

  // 4. Fully concatenated + leet (catches "sh 1 t" → "shit" as exact match)
  const concatenated = leet.replace(/[\s\-_.]+/g, '');
  if (profanity.exists(concatenated)) {
    return true;
  }

  return false;
};
